import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    createPaymentRequest,
    checkPaymentStatusRequest,
    getPaymentHistoryRequest,
} from '../../../../services/network/common/payment';

export const createPayment = createAsyncThunk(
    'payment/createPayment',
    async (payload, thunkAPI) => {
        try {
            const params = await createPaymentRequest(payload);
            return params;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || error.message,
            );
        }
    },
);

export const checkPaymentStatus = createAsyncThunk(
    'payment/checkPaymentStatus',
    async (orderId, thunkAPI) => {
        try {
            return await checkPaymentStatusRequest(orderId);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || error.message,
            );
        }
    },
);

export const getPaymentHistory = createAsyncThunk(
    'payment/getPaymentHistory',
    async ({ limit = 10, offset = 0 } = {}, thunkAPI) => {
        try {
            return await getPaymentHistoryRequest(limit, offset);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || error.message,
            );
        }
    },
);
